import React, { useEffect, useState } from "react";
import AdminHeading from "../Heading/AdminHeading";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import "../../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a18,
  a20,
  a22,
  a28,
  a30,
  a33,
  a35,
  a68,
  a7,
  a71,
  a72,
  a89,
  s1,
} from "../../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import { FaImages } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import AlertMessage from "../../../Other Functions/AlertMessage";

export default function AdminAddSku() {
  const [active, setActive] = useState("List");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [totalMetalAmount, setTotalMetalAmount] = useState("");
  const [totalLabourAmount, setLabourAmount] = useState("");
  const [totalStoneAmount, setTotalStoneAmount] = useState("");
  const [totalProductAmount, setTotalProductAmount] = useState("");
  const [filesType, setFilesType] = useState(true);
  const [selectedSkuId, setSelectedSkuId] = useState(0);
  const [partyTypeId, setPartyTypeId] = useState("");
  const [category, setCategory] = useState("");
  const [productType, setProductType] = useState("");
  const [collection, setCollection] = useState("");
  const [purity, setPurity] = useState("");
  const [productTypeData, setProductTypeData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [partyData, setPartyData] = useState([]);
  const [boxData, setBoxData] = useState([]);
  const [collectionTypeData, setCollectionTypeData] = useState([]);

  const [stockKeepingUnit, setStockKeepingUnit] = useState("");
  const [productRemark, setProductRemark] = useState("");
  const [grosswt, setGrosswt] = useState(0);
  const [netWt, setNetWt] = useState(0);
  const [stoneWeight, setStoneWeight] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [size, setSize] = useState("");
  const [description, setDescription] = useState("");
  const [making_per_gram, setMaking_per_gram] = useState(0);
  const [making_Fixed_Amt, setMaking_Fixed_Amt] = useState(0);
  const [making_Percentage, setMaking_Percentage] = useState(0);
  const [making_Fixed_Wastage, setMaking_Fixed_Wastage] = useState(0);
  const [mrp, setMRP] = useState(0);
  const [color, setColor] = useState("");
  const [stoneAmount1, setStoneAmount1] = useState(0);
  const [stoneAmount2, setStoneAmount2] = useState(0);
  const [stoneAmount3, setStoneAmount3] = useState(0);
  const [stoneAmount4, setStoneAmount4] = useState(0);
  const [stoneName1, setStoneName1] = useState("");
  const [stoneName2, setStoneName2] = useState("");
  const [stoneName3, setStoneName3] = useState("");
  const [stoneName4, setStoneName4] = useState("");
  const [stoneWt1, setStoneWt1] = useState(0);
  const [stoneWt2, setStoneWt2] = useState(0);
  const [stoneWt3, setStoneWt3] = useState(0);
  const [stoneWt4, setStoneWt4] = useState(0);
  const [stonePieces1, setStonePieces1] = useState(1);
  const [stonePieces2, setStonePieces2] = useState(1);
  const [stonePieces3, setStonePieces3] = useState(1);
  const [stonePieces4, setStonePieces4] = useState(1);
  const [selectedStoneRate, setSelectedStoneRate] = useState(1);
  const [saleType, setSaleType] = useState("MRP");
  const [stonePieces, setStonePieces] = useState(0);
  const [allStones, setAllStones] = useState([]);
  const [oldEntry, setOldEntry] = useState(false);

  const [allSku, setAllSku] = useState([]);
  const [newSku, setNewSku] = useState({
    stockKeepingUnit: "",
    description: "",
    productRemark: "",
    productType: "",
    purity: "",
    colour: "",
    category: "",
    collection: "",
    size: "0",
    grossWt: "0",
    netWt: "0",
    totalStoneWt: "0",
    images: "",
    stoneAmount1: "0",
    stoneAmount2: "0",
    stoneAmount3: "0",
    stoneAmount4: "0",
    stoneName1: "",
    stoneName2: "",
    stoneName3: "",
    stoneName4: "",
    stoneWt1: "0",
    stoneWt2: "0",
    stoneWt3: "0",
    stoneWt4: "0",
    stonePieces1: "0",
    stonePieces2: "0",
    stonePieces3: "0",
    stonePieces4: "0",
    makingPercentage: "0",
    makingFixedAmt: "0",
    makingFixedWastage: "0",
    makingPerGram: "0",
    mrp: "0",
    saleType: "MRP",
    stonePieces: "0",
    purityId: 0,
    productTypeId: 0,
    collectionId: 0,
    categoryId: 0,
    oldEntry: false,
  });
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  let Entryby_Staff_id = parseInt(adminLoggedIn);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllSku = async () => {
    try {
      const response = await fetch(a71);
      const data = await response.json();
      console.log(data);
      setAllSku(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllSku();
  }, []);
  console.log(allSku);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allSku.find((x) => x.id === id);
    setEditedData(selectedItem);
  };

  const handleSaveClick = () => {
    handleSubmit();
    // Save the edited data to your state or send it to an API
    console.log("Edited Data:", editedData);
    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(a35, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
      } else {
        setMessageType("success");
        setMessageToShow("Updated successfully");
        setShowError(true);
      }
      console.log(data, "updated");
      fetchAllSku();
    } catch (error) {
      console.error(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
  };

  const handleNewSkuChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewSku({ ...newSku, [name]: value });
  };
  const addNewSku = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Append regular fields
    formData.append("StockKeepingUnit", stockKeepingUnit.toUpperCase());
    formData.append("Description", description);
    formData.append("ProductRemark", productRemark);
    formData.append("ProductType", productTypeName);
    formData.append("Purity", purityName);
    formData.append("Colour", color);
    formData.append("Collection", collectionName);
    formData.append("CategoryId", parseInt(categoryId)); // Convert to string
    formData.append("Category", categoryName.toString()); // Convert to string
    formData.append("Size", size);
    formData.append("GrossWt", grosswt.toString()); // Convert to string
    formData.append("NetWt", netWt.toString()); // Convert to string
    formData.append("TotalStoneWt", stoneWeight.toString()); // Convert to string

    // Append StoneAmounts, StoneNames, StoneWts
    formData.append("StoneAmount1", stoneAmount1.toString()); // Convert to string
    formData.append("StoneAmount2", stoneAmount2.toString()); // Convert to string
    formData.append("StoneAmount3", stoneAmount3.toString()); // Convert to string
    formData.append("StoneAmount4", stoneAmount4.toString()); // Convert to string
    formData.append("StoneName1", stoneName1);
    formData.append("StoneName2", stoneName2);
    formData.append("StoneName3", stoneName3);
    formData.append("StoneName4", stoneName4);
    formData.append("StoneWt1", stoneWt1.toString()); // Convert to string
    formData.append("StoneWt2", stoneWt2.toString()); // Convert to string
    formData.append("StoneWt3", stoneWt3.toString()); // Convert to string
    formData.append("StoneWt4", stoneWt4.toString()); // Convert to string
    formData.append("StonePieces1", stonePieces1.toString()); // Convert to string
    formData.append("StonePieces2", stonePieces2.toString()); // Convert to string
    formData.append("StonePieces3", stonePieces3.toString()); // Convert to string
    formData.append("StonePieces4", stonePieces4.toString()); // Convert to string

    // Append other fields
    formData.append("MakingPercentage", making_Percentage.toString()); // Convert to string
    formData.append("MakingFixedAmt", making_Fixed_Amt.toString()); // Convert to string
    formData.append("MakingFixedWastage", making_Fixed_Wastage.toString()); // Convert to string
    formData.append("MakingPerGram", making_per_gram.toString()); // Convert to string
    formData.append("MRP", mrp.toString()); // Convert to string
    formData.append("SaleType", saleType);
    formData.append("StonePieces", stonePieces.toString()); // Convert to string
    formData.append("PurityId", parseInt(purityId));
    formData.append("ProductTypeId", parseInt(productTypeId));
    formData.append("CollectionId", parseInt(collectionId)); // Convert to string
    oldEntry ? formData.append("Id", parseInt(selectedSkuId)) : null;
    // Images
    filesType
      ? selectedFiles.forEach((file) => {
          formData.append("Images", file);
        })
      : formData.append("Images", selectedFiles);

    // Now you can use this formData object in your fetch request
    console.log(formData, "formData");
    for (const entry of formData.entries()) {
      console.log(entry);
    }
    try {
      const response = await fetch(!oldEntry ? a72 : a89, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      fetchAllSku();
      setActive("List");
      setNewSku({
        stockKeepingUnit: "",
        description: "",
        productRemark: "",
        productType: "",
        purity: "",
        colour: "",
        category: "",
        collection: "",
        size: "0",
        grossWt: "0",
        netWt: "0",
        totalStoneWt: "0",
        images: "",
        stoneAmount1: "0",
        stoneAmount2: "0",
        stoneAmount3: "0",
        stoneAmount4: "0",
        stoneName1: "",
        stoneName2: "",
        stoneName3: "",
        stoneName4: "",
        stoneWt1: "0",
        stoneWt2: "0",
        stoneWt3: "0",
        stoneWt4: "0",
        stonePieces1: "0",
        stonePieces2: "0",
        stonePieces3: "0",
        stonePieces4: "0",
        makingPercentage: "0",
        makingFixedAmt: "0",
        makingFixedWastage: "0",
        makingPerGram: "0",
        mrp: "0",
        saleType: "",
        stonePieces: "0",
        purityId: 0,
        productTypeId: 0,
        collectionId: 0,
        categoryId: 0,
        oldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("SKU Added Successfully");
        setShowError(true);
      }
      resetStateValues();
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };
  const resetStateValues = () => {
    setPartyTypeId("");
    setCategory("");
    setProductType("");
    setCollection("");
    setPurity("");
    // setProductTypeData([]);
    // setCategoriesData([]);
    // setPurityData([]);
    // setPartyData([]);
    // setBoxData([]);
    // setCollectionTypeData([]);

    setStockKeepingUnit("");
    setProductRemark("");
    setGrosswt(0);
    setNetWt(0);
    setStoneWeight(0);
    setSelectedFiles([]);
    setSize("0");
    setDescription("");
    setMaking_per_gram(0);
    setMaking_Fixed_Amt(0);
    setMaking_Percentage(0);
    setMaking_Fixed_Wastage(0);
    setMRP(0);
    setColor("");
    setStoneAmount1(0);
    setStoneAmount2(0);
    setStoneAmount3(0);
    setStoneAmount4(0);
    setStoneName1("");
    setStoneName2("");
    setStoneName3("");
    setStoneName4("");
    setStoneWt1(0);
    setStoneWt2(0);
    setStoneWt3(0);
    setStoneWt4(0);
    setSaleType("MRP");
    setStonePieces(0);
    // setAllStones([]);
    setFilesType(true);
    setOldEntry(false);
    setSelectedSkuId(0);
  };
  //   Add bulk stock

  useEffect(() => {
    fetch(a18)
      .then((res) => res.json())
      .then((data) => setCategoriesData(data.data));
  }, []);
  useEffect(() => {
    fetch(a20)
      .then((x) => x.json())
      .then((y) => setProductTypeData(y.data));
  }, []);
  // console.log(productTypeData.category_id);

  useEffect(() => {
    fetch(a22)
      .then((res) => res.json())
      .then((data) => setPurityData(data.data));
    // console.log(purityData);
  }, []);
  useEffect(() => {
    fetch(a28)
      .then((res) => res.json())
      .then((data) => setPartyData(data.data.result));
  }, []);
  useEffect(() => {
    fetch(a33)
      .then((res) => res.json())
      .then((data) => setCollectionTypeData(data.data));
  }, []);
  // console.log(partyData);
  useEffect(() => {
    fetch(a30)
      .then((res) => res.json())
      .then((data) => setBoxData(data.data));
  }, []);
  useEffect(() => {
    fetch(a68)
      .then((res) => res.json())
      .then((data) => setAllStones(data.data));
  }, []);

  let categoryId = parseInt(category.split(",")[0]);
  let categoryName = category.split(",")[1];
  let productTypeId = parseInt(productType.split(",")[0]);
  let productTypeName = productType.split(",")[1];
  let collectionId = parseInt(collection.split(",")[0]);
  let collectionName = collection.split(",")[1];
  let purityId = purity !== "" ? parseInt(purity.split(",")[0]) : 0;
  let purityName = purity.split(",")[1];
  let partyId = parseInt(partyTypeId.split(",")[0]);
  let partyName = partyTypeId.split(",")[1];

  const filteredProducts = productTypeData.filter(
    (product) => product.category_id == categoryId
  );
  const filteredCollection = collectionTypeData.filter(
    (product) => product.productType == productTypeName
  );
  const filteredPurity = purityData.filter(
    (product) => product.category == categoryName
  );
  const filteredBoxes = boxData.filter(
    (product) => product.productName == productTypeName
  );
  const handleStoneName = (value, stoneNumber) => {
    // let stoneName = value.split(",")[0];
    // let stoneRate = value.split(",")[1];
    if (stoneNumber == 1) {
      setStoneName1(value);
      //   setStoneAmount1();
    }
  };
  const [stones, setStones] = useState([
    { stoneName: "", stoneWeight: "", stoneAmount: "", stonePieces: "" },
  ]);

  const addStone = () => {
    if (stones.length < 4) {
      setStones([
        ...stones,
        { stoneName: "", stoneWeight: "", stoneAmount: "", stonePieces: "" },
      ]);
    }
  };

  const removeStone = (index) => {
    const updatedStones = [...stones];
    updatedStones.splice(index, 1);
    setStones(updatedStones);

    eval(`setStoneAmount${index + 1}`)(0);
    eval(`setStoneName${index + 1}`)("");
    eval(`setStoneWt${index + 1}`)(0);
    eval(`setStonePieces${index + 1}`)(1);
  };

  //   const updateStone = (index, field, value) => {
  //     const updatedStones = [...stones];
  //     updatedStones[index][field] = value;
  //     setStones(updatedStones);

  //     // Update corresponding state based on the field and index
  //     switch (field) {
  //       case "stoneAmount":
  //         eval(`setStoneAmount${index + 1}`)(value);
  //         break;
  //       case "stoneName":
  //         eval(`setStoneName${index + 1}`)(value);
  //         break;
  //       case "stoneWeight":
  //         eval(`setStoneWt${index + 1}`)(value);
  //         break;
  //       default:
  //         break;
  //     }
  //   };
  const updateStone = (index, field, value) => {
    const updatedStones = [...stones];
    const updatedStone = { ...updatedStones[index], [field]: value };
    // Update stone amount based on the rate from allStones when the field is "stoneName"
    if (field === "stoneName") {
      const selectedStoneFromAllStones = allStones.find(
        (stone) => stone.stoneName === value
      );
      if (selectedStoneFromAllStones) {
        updatedStone.stoneAmount = selectedStoneFromAllStones.rate;
        eval(`setStoneAmount${index + 1}`)(selectedStoneFromAllStones.rate);
        setSelectedStoneRate(selectedStoneFromAllStones.rate);
      }
    }

    // If the field is "stoneAmount" or "stonePieces", update the total amount
    if (field === "stoneAmount" || field === "stonePieces") {
      const stonePieces =
        field === "stonePieces" ? value : updatedStone.stonePieces || 0;
      updatedStone.stoneAmount =
        value > 1 ? value * updatedStone.stoneAmount : selectedStoneRate;
      const stoneAmount =
        field === "stoneAmount" ? value : updatedStone.stoneAmount || 0;
      const totalAmount = stonePieces * stoneAmount;
      updatedStone.totalAmount = totalAmount; // Assuming there's a totalAmount field to hold the product
      // Optionally, update a state for totalAmount if needed
    }
    if (field === "stoneWeight") {
      if (value !== "") {
        setGrosswt(
          parseFloat(netWt) + +parseFloat(stoneWeight) + parseFloat(value)
        );
        setStoneWeight(parseFloat(stoneWeight) + parseFloat(value));
      }
    }

    updatedStones[index] = updatedStone;
    setStones(updatedStones);
    console.log(updatedStone, "updatedStone");
    console.log(updatedStone, "updatedStone");
    console.log(updatedStone, "updatedStone");
    // Update corresponding state based on the field and index
    switch (field) {
      case "stoneAmount":
        eval(`setStoneAmount${index + 1}`)(value);
        break;
      case "stoneName":
        eval(`setStoneName${index + 1}`)(value);
        break;
      case "stoneWeight":
        eval(`setStoneWt${index + 1}`)(value);
        break;
      case "stonePieces":
        eval(`setStonePieces${index + 1}`)(value);
        // If you have a state for totalAmount, update it here
        // eval(`setTotalAmount${index + 1}`)(totalAmount); // Assuming you have such state handlers
        break;
      default:
        break;
    }
  };

  const handleFileInputChange = (event) => {
    const files = event.target.files;
    const validFileCount = Math.min(files.length, 5 - selectedFiles.length);

    // Condition to reset the file selection
    if (!oldEntry || filesType) {
      // If we're not in a reset condition or if filesType is true, append new files respecting the limit
      const newFiles = Array.from(files).slice(0, validFileCount);
      setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    } else {
      // Reset condition met, prepare to replace selectedFiles entirely
      setFilesType(true); // Assuming this is needed to indicate the type/state of file selection
      // Since we're resetting, consider the total limit from scratch
      const newFiles = Array.from(files).slice(0, Math.min(files.length, 5));
      setSelectedFiles(newFiles);
    }
  };

  const handleFileInputChangeRemove = (indexToRemove) => {
    const newSet = selectedFiles.filter(
      (file, index) => index !== indexToRemove
    );
    setSelectedFiles(newSet);
    if (selectedFiles.length == 1) {
      setSelectedFiles([]);
    }
  };

  //   console.log(stoneName1, "stoneName1");
  //   console.log(stoneAmount1, "stoneAmount1");
  //   console.log(stoneName2, "stoneName2");
  //   console.log(stoneAmount2, "stoneAmount2");
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  useEffect(() => {
    let selectedPurityRate = purityId
      ? purityData.filter((x) => x.id == purityId)[0].todaysRate
      : 0;
    console.log(selectedPurityRate, "selectedPurityRate");
    let TotalMetAmount = (netWt * selectedPurityRate) / 10;
    setTotalMetalAmount((netWt * selectedPurityRate) / 10);
    console.log(totalMetalAmount, "totalMetalAmount");

    let TotalStoneAmount = stones.reduce(
      (a, b) => a + parseFloat(b.stoneAmount),
      0
    );
    setTotalStoneAmount(TotalStoneAmount);

    let makingCharge1 =
      (((selectedPurityRate * netWt) / 10) * making_Percentage) / 100;
    let makingCharge2 = netWt * making_per_gram;
    let makingCharge3 = making_Fixed_Amt;
    let TotalMaking =
      parseFloat(makingCharge1) +
      parseFloat(makingCharge2) +
      parseFloat(makingCharge3);

    setLabourAmount(TotalMaking);
    calculateTotalProductPrice(
      TotalMetAmount,
      TotalStoneAmount,
      TotalMaking,
      mrp
    );
  }, [
    netWt,
    purity,
    grosswt,
    stoneWeight,
    stones,
    making_Percentage,
    making_per_gram,
    making_Fixed_Amt,
    mrp,
  ]);
  const calculateTotalProductPrice = (metal, stone, making, mrp) => {
    setTotalProductAmount(() => {
      // Ensure mrp is used directly if valid, otherwise calculate the sum, defaulting each part to 0 if not a valid number
      return mrp && !isNaN(mrp) && parseFloat(mrp) !== 0
        ? parseFloat(mrp)
        : (isNaN(metal) ? 0 : parseFloat(metal)) +
            (isNaN(stone) ? 0 : parseFloat(stone)) +
            (isNaN(making) ? 0 : parseFloat(making));
    });
  };

  const resetAllFields = () => {
    setShowError(false);
    setMessageType("");
    setMessageToShow("");
    setTotalMetalAmount("");
    setLabourAmount("");
    setTotalStoneAmount("");
    setTotalProductAmount("");

    setNewSku({
      stockKeepingUnit: "",
      description: "",
      productRemark: "",
      productType: "",
      purity: "",
      colour: "",
      category: "",
      collection: "",
      size: "0",
      grossWt: "0",
      netWt: "0",
      totalStoneWt: "0",
      images: "",
      stoneAmount1: "0",
      stoneAmount2: "0",
      stoneAmount3: "0",
      stoneAmount4: "0",
      stoneName1: "",
      stoneName2: "",
      stoneName3: "",
      stoneName4: "",
      stoneWt1: "0",
      stoneWt2: "0",
      stoneWt3: "0",
      stoneWt4: "0",
      stonePieces1: "0",
      stonePieces2: "0",
      stonePieces3: "0",
      stonePieces4: "0",
      makingPercentage: "0",
      makingFixedAmt: "0",
      makingFixedWastage: "0",
      makingPerGram: "0",
      mrp: "0",
      saleType: "MRP",
      stonePieces: "0",
      purityId: 0,
      productTypeId: 0,
      collectionId: 0,
      categoryId: 0,
      oldEntry: false,
    });

    // Resetting additional states involved in your form
    setPartyTypeId("");
    setCategory("");
    setProductType("");
    setCollection("");
    setPurity("");

    setStockKeepingUnit("");
    setProductRemark("");
    setGrosswt(0);
    setNetWt(0);
    setStoneWeight(0);
    setSelectedFiles([]);
    setSize("0");
    setDescription("");
    setMaking_per_gram(0);
    setMaking_Fixed_Amt(0);
    setMaking_Percentage(0);
    setMaking_Fixed_Wastage(0);
    setMRP(0);
    setColor("");
    setStoneAmount1(0);
    setStoneAmount2(0);
    setStoneAmount3(0);
    setStoneAmount4(0);
    setStoneName1("");
    setStoneName2("");
    setStoneName3("");
    setStoneName4("");
    setStoneWt1(0);
    setStoneWt2(0);
    setStoneWt3(0);
    setStoneWt4(0);
    setStonePieces1(1);
    setStonePieces2(1);
    setStonePieces3(1);
    setStonePieces4(1);
    setSaleType("MRP");
    setStonePieces(0);
    setStones([
      { stoneName: "", stoneWeight: "", stoneAmount: "", stonePieces: "" },
    ]);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewSku({ ...data, oldEntry: true });
    setActive("AddNew");
    setStockKeepingUnit(data.stockKeepingUnit);
    setDescription(data.description);
    setProductRemark(data.productRemark);
    setCategory(`${data.categoryId},${data.category}`);
    categoryName = data.category;
    categoryId = data.categoryId;
    setProductType(`${data.productTypeId},${data.productType}`);
    productTypeName = data.productType;
    productTypeId = data.productTypeId;
    setCollection(`${data.collectionId},${data.collection}`);
    collectionName = data.collection;
    collectionId = data.collectionId;
    setPurity(`${data.purityId},${data.purity}`);
    purityName = data.purity;
    purityId = data.purityId;
    setColor(data.colour);
    setSize(data.size);
    setGrosswt(data.grossWt);
    setStoneWeight(data.totalStoneWt);
    setNetWt(data.netWt);
    setMaking_Percentage(data.makingPercentage);
    setMaking_per_gram(data.makingPerGram);
    setMaking_Fixed_Amt(data.makingFixedAmt);
    setMaking_Fixed_Wastage(data.makingFixedWastage);
    setStoneAmount1(data.stoneAmount1);
    setStoneAmount2(data.stoneAmount2);
    setStoneAmount3(data.stoneAmount3);
    setStoneAmount4(data.stoneAmount4);
    setStoneName1(data.stoneName1);
    setStoneName2(data.stoneName2);
    setStoneName3(data.stoneName3);
    setStoneName4(data.stoneName4);
    setStonePieces(data.stonePieces);
    setStonePieces1(data.stonePieces1);
    setStonePieces2(data.stonePieces2);
    setStonePieces3(data.stonePieces3);
    setStonePieces4(data.stonePieces4);
    setStoneWt1(data.stoneWt1);
    setStoneWt2(data.stoneWt2);
    setStoneWt3(data.stoneWt3);
    setStoneWt4(data.stoneWt4);
    setOldEntry(true);
    setFilesType(false);
    setSelectedFiles(data.images);
    setSelectedSkuId(data.id);
    setStones([
      {
        stoneName: data.stoneName1.toString(),
        stoneWeight: data.stoneWt1.toString(),
        stoneAmount: data.stoneAmount1,
        stonePieces: data.stonePieces1.toString(),
      },
      {
        stoneName: data.stoneName2.toString(),
        stoneWeight: data.stoneWt2.toString(),
        stoneAmount: data.stoneAmount2,
        stonePieces: data.stonePieces2.toString(),
      },
      {
        stoneName: data.stoneName3.toString(),
        stoneWeight: data.stoneWt3.toString(),
        stoneAmount: data.stoneAmount3,
        stonePieces: data.stonePieces3.toString(),
      },
      {
        stoneName: data.stoneName4.toString(),
        stoneWeight: data.stoneWt4.toString(),
        stoneAmount: data.stoneAmount4,
        stonePieces: data.stonePieces4.toString(),
      },
    ]);
  };
  console.log(selectedFiles, "selectedFiles");
  console.log(selectedFiles, "selectedFiles");
  console.log(newSku, "newSku");
  console.log(newSku, "newSku");

  // You now have a File object

  //   Add bulk stock
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add SKU"}
          companyName={"Loyalstring"}
          module={"Masters"}
          page={"SKU"}
        />
        <div className="adminAddCategoryMainBox">
          <div className="adminAddCategoryInnerBox">
            <div className="adminAddCategoryInnerBoxTitlesBox">
              <div
                onClick={() => {
                  setActive("List");
                }}
                className={
                  active === "List"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "List"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 01 */}
                  <RiListUnordered />
                </div>
                <p>All SKU</p>
              </div>

              <div
                onClick={() => setActive("AddNew")}
                className={
                  active === "AddNew"
                    ? "adminAddCategoryInnerBoxTitle"
                    : "adminAddCategoryInnerBoxTitle activeCategoryTitle"
                }
              >
                <div
                  className={
                    active === "AddNew"
                      ? "adminAddCategoryInnerBoxTitleLogo"
                      : "adminAddCategoryInnerBoxTitleLogo activeCategoryLogo"
                  }
                >
                  {/* 02 */}
                  <RiPlayListAddLine />
                </div>
                <p>Add SKU</p>
              </div>
            </div>
            <div
              className={
                active === "List" ? "adminCategoryListMainBox" : "none"
              }
            >
              <table>
                <thead>
                  <tr>
                    <th>Edit</th>
                    <th>ID</th>
                    <th>SKU</th>
                    <th>Category</th>
                    <th>Product Type</th>
                    <th>Collection</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {allSku.map((x) => (
                    <tr key={x.id}>
                      <td>
                        {editingId === x.id ? (
                          <button
                            className="adminAddCategorySaveButton"
                            onClick={handleSaveClick}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            className="adminAddCategoryEditButton"
                            // onClick={() => handleEditClick(x.id)}
                            onClick={() => handleEditData(x)}
                          >
                            Edit
                          </button>
                        )}
                      </td>
                      <td>{x.id}</td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="stockKeepingUnit"
                            value={editedData.stockKeepingUnit || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.stockKeepingUnit
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="category"
                            value={editedData.category || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.category
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="productType"
                            value={editedData.productType} // Convert to uppercase
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.productType
                        )}
                      </td>
                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="collection"
                            value={editedData.collection} // Convert to uppercase
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.collection
                        )}
                      </td>

                      <td>
                        {editingId === x.id ? (
                          <input
                            type="text"
                            name="description"
                            value={editedData.description || ""}
                            onChange={handleInputChange}
                          />
                        ) : (
                          x.description
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className={
                active !== "List" ? "adminCategoryAddCategoryMainBox" : "none"
              }
            >
              <p>Add New Sku</p>
              <form onSubmit={addNewSku}>
                <div className="adminCategoryAddCategoryInnerBox">
                  <div className="adminSkuAddSkuInnerBox">
                    <div
                      style={{ gridColumn: "1 span" }}
                      className="adminSkuAddSkuInnerUpperItemsBox"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <label>
                          SKU <sup> *</sup>
                        </label>
                        <input
                          type="text"
                          value={stockKeepingUnit}
                          onChange={(e) => {
                            setStockKeepingUnit(e.target.value.toUpperCase());
                          }}
                        />
                        <label style={{ margin: 0, cursor: "pointer" }}>
                          Images{" "}
                          {`${
                            filesType
                              ? selectedFiles.length
                              : selectedFiles.split(",").length
                          }`}
                          <FaImages
                            style={{ margin: "1.2rem", marginInline: "1rem" }}
                            size={"2.5rem"}
                          />
                          <input
                            id="images"
                            style={{ display: "none" }}
                            type="file"
                            onChange={handleFileInputChange}
                            multiple
                          />
                        </label>
                      </div>
                    </div>
                    {/* <div
                      style={{ gridColumn: "span 0.2" }}
                      className="adminSkuAddSkuInnerUpperItemsBox"
                    >
                    
                      <label style={{ margin: 0, cursor: "pointer" }}>
                        Images {`${selectedFiles.length}`}
                        <FaImages
                          style={{ margin: "1.2rem", marginInline: "1rem" }}
                          size={"2.5rem"}
                        />
                        <input
                          id="images"
                          style={{ display: "none" }}
                          type="file"
                          onChange={handleFileInputChange}
                          multiple
                        />
                      </label>
                    
                    </div> */}
                    <div
                      style={{ gridColumn: "span 2", overflowX: "auto" }}
                      className="adminSkuAddSkuInnerUpperItemsBox"
                    >
                      <div className="adminSkuAddSkuInnerItemsImagesBox">
                        {filesType && selectedFiles.length > 0
                          ? selectedFiles.map((file, index) => (
                              <div className="adminSkuAddSkuInnerItemsImagesInnerBox">
                                <img
                                  key={index}
                                  src={URL.createObjectURL(file)}
                                  alt={`Selected Image ${index + 1}`}
                                  style={{
                                    maxWidth: "50px",
                                    maxHeight: "50px",
                                    margin: "5px",
                                  }}
                                />
                                <div
                                  onClick={() =>
                                    handleFileInputChangeRemove(index)
                                  }
                                  className="adminSkuAddSkuInnerItemsImagesBoxCancel"
                                >
                                  <RxCross2 strokeWidth={"2px"} />
                                </div>
                              </div>
                            ))
                          : !filesType && oldEntry && selectedFiles !== ""
                          ? selectedFiles.split(",").map((image, index) => (
                              <div className="adminSkuAddSkuInnerItemsImagesInnerBox">
                                <img
                                  key={index}
                                  style={{
                                    maxWidth: "50px",
                                    maxHeight: "50px",
                                    margin: "5px",
                                  }}
                                  className="adminOrderDetailsItemsproductImage"
                                  src={`${s1}/${image.trim()}`}
                                  alt={`Product Image ${index + 1}`}
                                />
                                {/* <div
                                  onClick={() =>
                                    handleFileInputChangeRemoveExisting(index)
                                  }
                                  className="adminSkuAddSkuInnerItemsImagesBoxCancel"
                                >
                                  <RxCross2 strokeWidth={"2px"} />
                                </div> */}
                              </div>
                            ))
                          : null}
                      </div>
                    </div>
                    <div
                      style={{ gridColumn: "span 2" }}
                      className="adminSkuAddSkuInnerUpperItemsBox"
                    >
                      <label>Description</label>
                      <textarea
                        type="text"
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                        }}
                      />
                    </div>
                    <div
                      style={{ gridColumn: "span 1" }}
                      className="adminSkuAddSkuInnerUpperItemsBox"
                    >
                      <label>Product Remark</label>
                      <textarea
                        type="text"
                        value={productRemark}
                        onChange={(e) => {
                          setProductRemark(e.target.value);
                        }}
                      />
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>
                        Category <sup> *</sup>
                      </label>
                      <select
                        id="category"
                        required="required"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="">Category</option>
                        {categoriesData.map((x, y) => {
                          return (
                            <option key={y} value={`${x.id},${x.name}`}>
                              {x.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>
                        Product <sup> *</sup>
                      </label>
                      <select
                        id="productTypeId"
                        required="required"
                        value={productType}
                        onChange={(e) => setProductType(e.target.value)}
                      >
                        <option value="">Product Type</option>
                        {filteredProducts.map((x, y) => {
                          return (
                            <option
                              key={y}
                              value={`${parseInt(x.id)},${x.productTitle}`}
                            >
                              {x.productTitle}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>
                        Collection <sup> *</sup>
                      </label>
                      <select
                        id="collection"
                        required="required"
                        value={collection}
                        onChange={(e) => setCollection(e.target.value)}
                      >
                        <option value="">Colletion</option>
                        {filteredCollection.map((x, y) => {
                          return (
                            <option
                              key={y}
                              value={`${parseInt(x.id)},${x.collection_Name}`}
                            >
                              {x.collection_Name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>
                        Purity <sup> *</sup>
                      </label>
                      <select
                        id="purity"
                        required="required"
                        value={purity}
                        onChange={(e) => setPurity(e.target.value)}
                      >
                        <option value="">Purity</option>
                        {filteredPurity.map((x, y) => {
                          return (
                            <option
                              key={y}
                              value={`${parseInt(x.id)},${x.label}`}
                            >
                              {x.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>Colour</label>
                      <input
                        type="text"
                        value={color}
                        onChange={(e) => {
                          setColor(e.target.value);
                        }}
                      />
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label>Size</label>
                      <input
                        type="text"
                        value={size}
                        onChange={(e) => {
                          setSize(e.target.value);
                        }}
                      />
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label htmlFor="grosswt">
                        G.Wt <sup> *</sup>
                      </label>
                      <input
                        type="number"
                        id="grosswt"
                        required="required"
                        value={grosswt}
                        onChange={(e) => {
                          if (
                            e.target.value >= 0 &&
                            e.target.value > grosswt - stoneWeight
                          ) {
                            setGrosswt(e.target.value),
                              setNetWt(
                                parseFloat(e.target.value) -
                                  parseFloat(stoneWeight)
                              );
                          } else if (e.target.value >= 0) {
                            setGrosswt(e.target.value);
                            setStoneWeight(0);
                            setNetWt(e.target.value);
                          }
                        }}
                      />
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label htmlFor="stoneWeight">
                        Total St.Wt <sup> *</sup>
                      </label>

                      <input
                        type="number"
                        id="stoneWeight"
                        value={stoneWeight}
                        onChange={(e) => {
                          e.target.value >= 0 &&
                          e.target.value < parseFloat(grosswt)
                            ? (setStoneWeight(e.target.value),
                              setNetWt(
                                parseFloat(
                                  parseFloat(grosswt) -
                                    parseFloat(e.target.value)
                                ).toFixed(3)
                              ))
                            : null;
                        }}
                      />
                    </div>
                    <div className="adminSkuAddSkuInnerItemsBox">
                      <label htmlFor="netWt">Net.Wt</label>

                      <input
                        type="number"
                        id="netWt"
                        value={netWt}
                        readOnly
                        // onChange={(e) => {
                        //   setNetWt(e.target.value),
                        //     setGrosswt(
                        //       parseFloat(e.target.value) +
                        //         parseFloat(stoneWeight)
                        //     );
                        // }}
                      />
                    </div>
                    <p className="adminSkuAddSkuInnerTitles">ADD LABOUR</p>
                    {/* <div className="adminSkuAddSkuInnerUpperItemsBox">s */}
                    {/* <div className="adminSkuAddSkuInnerItemsBox">
                      <label>Sale Type</label>
                      <select
                        value={saleType}
                        onChange={(e) => setSaleType(e.target.value)}
                      >
                        <option value={"MRP"}>MRP Based</option>
                        <option value={"Weight"}>Weight Based</option>
                      </select>
                    </div> */}
                    {/* {saleType === "MRP" ? ( */}
                    {/* <div className="adminSkuAddSkuInnerItemsBox">
                      <label>MRP</label>
                      <input
                        type="number"
                        value={mrp}
                        onChange={(e) => {
                          setMRP(e.target.value);
                        }}
                      />
                    </div> */}

                    <>
                      <div className="adminSkuAddSkuInnerItemsBox">
                        <label>Making Percentage</label>
                        <input
                          type="number"
                          value={making_Percentage}
                          onChange={(e) => {
                            setMaking_Percentage(e.target.value);
                          }}
                        />
                      </div>
                      <div className="adminSkuAddSkuInnerItemsBox">
                        <label>Making Per/Gram</label>
                        <input
                          type="number"
                          value={making_per_gram}
                          onChange={(e) => {
                            setMaking_per_gram(e.target.value);
                          }}
                        />
                      </div>
                      <div className="adminSkuAddSkuInnerItemsBox">
                        <label>Making Fixed Amount</label>
                        <input
                          type="number"
                          value={making_Fixed_Amt}
                          onChange={(e) => {
                            setMaking_Fixed_Amt(e.target.value);
                          }}
                        />
                      </div>
                      {/* <div className="adminSkuAddSkuInnerItemsBox">
                        <label>Making Fixed Wastage</label>
                        <input
                          type="number"
                          value={making_Fixed_Wastage}
                          onChange={(e) => {
                            setMaking_Fixed_Wastage(e.target.value);
                          }}
                        />
                      </div> */}
                    </>

                    {/* <div className="adminSkuAddSkuInnerItemsBox">
                      <label>Stone Pieces</label>
                      <input
                        type="number"
                        value={stonePieces}
                        onChange={(e) => {
                          setStonePieces(e.target.value);
                        }}
                      />
                    </div> */}
                  </div>
                  <p className="adminSkuAddSkuInnerTitles">ADD STONE</p>
                  {/* <div className="adminSkuAddSkuInnerItemsBox">
                      <label>Stone Name 1</label>
                      <input
                        type="text"
                        value={stoneName1}
                        onChange={(e) => {
                          handleStoneName(e.target.value, 1);
                        }}
                        list="stonesList"
                      />
                      <datalist id="stonesList">
                        {allStones.map((stone, index) => (
                          <option key={index} value={`${stone.stoneName}`} />
                        ))}
                      </datalist>
                    </div> */}
                  <div className="adminSkuAddSkuInnerItemsStoneBox">
                    {stones.map((stone, index) => (
                      <div className="adminSkuAddSkuInnerItemsStoneInnerBox">
                        <div
                          key={index}
                          className="adminSkuAddSkuInnerItemsBox"
                        >
                          <input
                            type="text"
                            value={stone.stoneName}
                            placeholder={`Stone Name ${index + 1}`}
                            onChange={(e) =>
                              updateStone(index, "stoneName", e.target.value)
                            }
                            list="stonesList"
                          />
                          <datalist id="stonesList">
                            {allStones.map((stone, index) => (
                              <option
                                key={index}
                                value={`${stone.stoneName}`}
                              />
                            ))}
                          </datalist>
                        </div>
                        <div className="adminSkuAddSkuInnerItemsBox">
                          <input
                            type="text"
                            value={stone.stoneWeight}
                            placeholder={`Stone Weight ${index + 1}`}
                            onChange={(e) =>
                              updateStone(index, "stoneWeight", e.target.value)
                            }
                          />
                        </div>
                        <div className="adminSkuAddSkuInnerItemsBox">
                          <input
                            type="text"
                            value={stone.stonePieces}
                            placeholder={`Stone Pieces ${index + 1}`}
                            onChange={(e) =>
                              updateStone(index, "stonePieces", e.target.value)
                            }
                          />
                        </div>
                        <div className="adminSkuAddSkuInnerItemsBox">
                          <input
                            type="text"
                            value={stone.stoneAmount}
                            placeholder={`Stone Amount ${index + 1}`}
                            onChange={(e) =>
                              updateStone(index, "stoneAmount", e.target.value)
                            }
                          />
                        </div>
                        {/* {stones.length > 1 && ( */}
                        <div className="adminSkuAddSkuInnerItemsBox">
                          <button
                            type="button"
                            onClick={() => removeStone(index)}
                          >
                            Remove
                          </button>
                        </div>
                        {/* )} */}
                      </div>
                    ))}
                    {stones.length < 4 ? (
                      <button
                        type="button"
                        className="adminSkuAddSkuInnerAddStoneButton"
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                        onClick={() => addStone()}
                      >
                        Add Stone
                      </button>
                    ) : null}
                  </div>
                  <div
                    style={{ gridColumn: "span 3" }}
                    className="adminSkuAddSkuInnerItemsBox"
                  >
                    <table>
                      <thead>
                        <tr>
                          <td>METAL AMOUNT</td>
                          <td>STONE AMOUNT</td>
                          <td>LABOUR AMOUNT</td>
                          <td>TOTAL AMOUNT</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {totalMetalAmount
                              ? parseFloat(totalMetalAmount).toFixed(0)
                              : 0}
                          </td>
                          <td>
                            {totalStoneAmount
                              ? parseFloat(totalStoneAmount).toFixed(0)
                              : 0}
                          </td>
                          <td>
                            {totalLabourAmount
                              ? parseFloat(totalLabourAmount).toFixed(0)
                              : 0}
                          </td>
                          <td>{totalProductAmount}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{ gridColumn: "span 3" }}
                    className="adminSkuAddSkuInnerItemsBox"
                  >
                    <label style={{ marginBottom: "5px" }}>MRP</label>
                    <input
                      type="number"
                      value={mrp}
                      onChange={(e) => {
                        e.target.value !== ""
                          ? setMRP(e.target.value)
                          : setMRP(0);
                      }}
                    />
                  </div>
                  <div
                    style={{ gridColumn: "span 1" }}
                    className="adminSkuAddSkuInnerItemsBox"
                  >
                    <button style={{ width: "200px" }} type="submit">
                      SUBMIT
                    </button>
                  </div>
                  {/* <div
                    style={{ gridColumn: "span 1" }}
                    className="adminSkuAddSkuInnerItemsBox"
                  > */}
                  <button
                    onClick={resetAllFields}
                    style={{ width: "200px" }}
                    type="button"
                  >
                    Reset
                  </button>
                  {/* </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
